// extracted by css-extract-rspack-plugin
export default {"selectbox":"unsFm"};